import { createFileRoute } from '@tanstack/react-router';

import { ClinicalWorkPage } from '@/features/emr';
export const Route = createFileRoute('/_authenticated/assistant')({
  component: () => <ClinicalWorkPage initialView="assistant" />,
  beforeLoad: () => ({ breadcrumbs: [{ href: '/encounters', title: 'Inbox' }, { href: '/assistant', title: 'Assistant' }] }),
});
